'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getClassName = function getClassName(inline, styled, className, use) {
  return (0, _reactUtils.classNames)('uiList', {
    'private-list--inline': inline,
    'private-list--inline-divided': use === 'inline-divided',
    'private-list--unstyled': !styled
  }, className);
};

var renderItems = function renderItems(children, childClassName) {
  return _react.Children.map(children, function (child) {
    if (child == null) {
      return null;
    }

    var className = (0, _reactUtils.classNames)('uiListItem', 'private-list__item', childClassName);

    return _react2.default.createElement(
      'li',
      { className: className },
      child
    );
  });
};

var renderOrdered = function renderOrdered(rest, computedClassName, renderedItems) {
  return _react2.default.createElement(
    'ol',
    _extends({}, rest, { className: computedClassName }),
    renderedItems
  );
};

var renderUnordered = function renderUnordered(rest, computedClassName, renderedItems) {
  return _react2.default.createElement(
    'ul',
    _extends({}, rest, { className: computedClassName }),
    renderedItems
  );
};

exports.default = _react2.default.createClass({
  displayName: 'UIList',

  propTypes: {
    childClassName: _react.PropTypes.string,
    className: _react.PropTypes.string,
    children: _react.PropTypes.node,
    inline: _react.PropTypes.bool.isRequired,
    ordered: _react.PropTypes.bool.isRequired,
    styled: _react.PropTypes.bool.isRequired,
    use: _react.PropTypes.oneOf(['default', 'inline-divided'])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      inline: false,
      ordered: false,
      styled: false,
      childClassName: '',
      use: 'default'
    };
  },
  render: function render() {
    var _props = this.props,
        ordered = _props.ordered,
        styled = _props.styled,
        inline = _props.inline,
        className = _props.className,
        children = _props.children,
        childClassName = _props.childClassName,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['ordered', 'styled', 'inline', 'className', 'children', 'childClassName', 'use']);

    var computedClassName = getClassName(inline, styled, className, use);
    var renderedItems = renderItems(children, childClassName);

    if (use === 'inline-divided' && !inline) {
      _devLogger2.default.warn({
        message: 'UIList: `inline` needs to be `true` when `use="inline-divided"` is set',
        key: 'UIList: use inline-divided requires inline'
      });
    }

    if (ordered) {
      return renderOrdered(rest, computedClassName, renderedItems);
    }
    return renderUnordered(rest, computedClassName, renderedItems);
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/list/UIList.js
// module id = 207
// module chunks = 0